// Angular
import {Injectable} from '@angular/core';
// RxJS
import {Subject} from 'rxjs';
import {USER_ROLE_SUUMO_CUSTOMER} from '../../../models/user.model';

@Injectable()
export class MenuConfigService {
    // Public properties
    onConfigUpdated$: Subject<any>;
    // Private properties
    private menuConfig: any;

    /**
     * Service Constructor
     */
    constructor() {
        // register on config changed event and set default config
        this.onConfigUpdated$ = new Subject();
    }

    /**
     * Returns the menuConfig
     */
    getMenus() {
        return this.menuConfig;
    }

    /**
     * Load config
     *
     * @param config: any
     */
    loadConfigs(config: any) {
        this.menuConfig = config;
        this.onConfigUpdated$.next(this.menuConfig);
    }

    generateMenu(menu: string, id: number | undefined | null = 0, role: number | undefined | null, isSuumo= false, pathToken: string | null = null) {
        switch (menu) {
            case 'team-project-management':
                switch (role) {
                    case 5:
                        this.loadConfigs({
                            header: {
                                self: {},
                                items: [
                                    {
                                        title: 'ダッシュボード',
                                        icon: 'ion ion-home',
                                        root: true,
                                        alignment: 'left',
                                        page: '/dashboard',
                                        translate: 'MENU.DASHBOARD'
                                    },
                                    {
                                        title: 'プロジェクト一覧',
                                        root: true,
                                        alignment: 'left',
                                        page: '/project-management',
                                        translate: 'MENU.PROJECTS'
                                    }
                                ]
                            },
                            aside: {
                                self: {},
                                items: [
                                    {
                                        title: 'ホーム',
                                        root: true,
                                        icon: 'la la-home',
                                        page: '/project-management/projects/' + id,
                                        translate: 'MENU.HOME',
                                        bullet: 'dot',
                                        'custom-class': 'kt-menu__home',
                                    },
                                    ...(isSuumo ? []
                                            : [{
                                                title: 'Chat Groups',
                                                root: true,
                                                icon: 'ion ion-android-list',
                                                page: '/project-management/chat-groups/' + id,
                                                translate: 'MENU.CHAT_GROUPS',
                                                bullet: 'dot',
                                            }]
                                    ),
                                    {
                                        title: 'Files',
                                        root: true,
                                        icon: 'ion ion-folder',
                                        page: '/project-management/files/' + id,
                                        translate: 'MENU.FILES',
                                        bullet: 'dot',
                                    },
                                    {
                                        title: 'Schedule',
                                        root: true,
                                        icon: 'ion ion-calendar',
                                        page: '/project-management/schedule/' + id,
                                        translate: 'MENU.SCHEDULE',
                                        bullet: 'dot',
                                    }
                                ]
                            },
                        });
                        break;
                    default:
                        this.loadConfigs({
                            header: {
                                self: {},
                                items: [
                                    {
                                        title: 'ダッシュボード',
                                        icon: 'ion ion-home',
                                        root: true,
                                        alignment: 'left',
                                        page: '/dashboard',
                                        translate: 'MENU.DASHBOARD'
                                    },
                                    {
                                        title: 'プロジェクト一覧',
                                        root: true,
                                        alignment: 'left',
                                        page: '/project-management',
                                        translate: 'MENU.PROJECTS'
                                    }
                                ]
                            },
                            aside: {
                                self: {},
                                items: [
                                    {
                                        title: 'ホーム',
                                        root: true,
                                        icon: 'la la-home',
                                        page: '/project-management/projects/' + id,
                                        translate: 'MENU.HOME',
                                        bullet: 'dot',
                                        'custom-class': 'kt-menu__home',
                                    },
                                    ...(
                                        role === USER_ROLE_SUUMO_CUSTOMER
                                        ? [] : [{
                                            title: 'Chat Groups',
                                            root: true,
                                            icon: 'ion ion-android-list',
                                            page: '/project-management/chat-groups/' + id,
                                            translate: 'MENU.CHAT_GROUPS',
                                            bullet: 'dot',
                                        }]
                                    ),
                                    {
                                        title: 'Files',
                                        root: true,
                                        icon: 'ion ion-folder',
                                        page: '/project-management/files/' + id,
                                        translate: 'MENU.FILES',
                                        bullet: 'dot',
                                    },
                                    {
                                        title: 'Gantt Chart',
                                        root: true,
                                        icon: 'ion ion-calendar',
                                        page: '/project-management/gantt-chart/' + id,
                                        translate: 'MENU.GANTT_CHART',
                                        bullet: 'dot',
                                    },
                                    {
                                        title: 'Project Settings',
                                        root: true,
                                        icon: 'ion ion-ios-settings-strong',
                                        page: '/project-management/settings/' + id,
                                        translate: 'MENU.PROJECT_SETTINGS',
                                        bullet: 'dot',
                                    }
                                ]
                            },
                        });
                        break;
                }
                break;
            case 'space-project-management':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト一覧',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: 'ホーム',
                                root: true,
                                icon: 'la la-home',
                                page: '/project-management/projects/' + id,
                                queryParams: pathToken ? {token: pathToken} : {},
                                translate: 'MENU.HOME',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            ...(role === USER_ROLE_SUUMO_CUSTOMER ? []
                                : [{
                                        title: 'Chat Groups',
                                        root: true,
                                        icon: 'ion ion-android-list',
                                        page: '/project-management/chat-groups/' + id,
                                        translate: 'MENU.CHAT_GROUPS',
                                        bullet: 'dot',

                                    }]
                            ),
                            {
                                title: 'Files',
                                root: true,
                                icon: 'ion ion-folder',
                                page: '/project-management/files/' + id,
                                queryParams: pathToken ? {token: pathToken} : {},
                                translate: 'MENU.FILES',
                                bullet: 'dot',
                            },
                            {
                                title: 'Schedule',
                                root: true,
                                icon: 'ion ion-calendar',
                                page: '/project-management/schedule/' + id,
                                queryParams: pathToken ? {token: pathToken} : {},
                                translate: 'MENU.SCHEDULE',
                                bullet: 'dot',
                            },
                            ...(
                                role !== USER_ROLE_SUUMO_CUSTOMER ? [{
                                    title: 'Project Settings',
                                    root: true,
                                    icon: 'ion ion-ios-settings-strong',
                                    page: '/project-management/settings/' + id,
                                    translate: 'MENU.PROJECT_SETTINGS',
                                    bullet: 'dot',
                                }] : []
                            )

                        ]
                    },
                });
                break;
            case 'team-my-settings':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト一覧',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: '個人設定',
                                root: true,
                                icon: 'ion ion-ios-settings-strong',
                                page: '/my-settings',
                                translate: 'MENU.MY_SETTINGS',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            {
                                section: 'Settings',
                            },
                            {
                                title: 'ユーザー情報',
                                root: true,
                                page: '/my-settings/user-info',
                                translate: 'MENU.USER_INFO',
                                bullet: 'dot',
                            },
                            {
                                title: 'パスワード',
                                root: true,
                                page: '/my-settings/password',
                                translate: 'MENU.PASSWORD',
                                bullet: 'dot',
                            }
                        ]
                    },
                });
                break;
            case 'space-my-settings':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト一覧',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: '個人設定',
                                root: true,
                                icon: 'ion ion-ios-settings-strong',
                                page: '/my-settings',
                                translate: 'MENU.MY_SETTINGS',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            {
                                section: 'Settings',
                            },
                            {
                                title: 'ユーザー情報',
                                root: true,
                                page: '/my-settings/user-info',
                                translate: 'MENU.USER_INFO',
                                bullet: 'dot',
                            },
                            {
                                title: 'パスワード',
                                root: true,
                                page: '/my-settings/password',
                                translate: 'MENU.PASSWORD',
                                bullet: 'dot',
                            }
                        ]
                    },
                });
                break;
            case 'space-management':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト一覧',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: 'スペース設定',
                                root: true,
                                icon: 'ion ion-android-settings',
                                page: '/space-management',
                                translate: 'MENU.SPACE_MANAGEMENT',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            {
                                section: 'Settings',
                                icon: 'ion ion-android-list',
                            },
                            {
                                title: 'スペースの編集',
                                root: true,
                                icon: 'ion ion-android-list',
                                page: '/space-management/settings',
                                translate: 'MENU.SPACE_SETTINGS',
                                bullet: 'dot',
                            },
                            {
                                section: 'Users'
                            },
                            {
                                title: 'ユーザー',
                                root: true,
                                icon: 'ion ion-android-people',
                                page: '/space-management/users',
                                translate: 'MENU.USERS',
                                bullet: 'dot',
                            },
                        ]
                    },
                });
                break;
            case 'team-management':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト一覧',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: 'チーム設定',
                                root: true,
                                icon: 'ion ion-ios-settings-strong',
                                page: '/team-management',
                                translate: 'MENU.TEAM_MANAGEMENT',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            {
                                section: 'Settings',
                                icon: 'ion ion-android-list',
                            },
                            {
                                title: 'チームの編集',
                                root: true,
                                icon: 'ion ion-android-settings',
                                page: '/team-management/settings',
                                translate: 'MENU.TEAM_SETTINGS',
                                bullet: 'dot',
                            },
                            {
                                section: 'Users'
                            },
                            {
                                title: 'ユーザー',
                                root: true,
                                icon: 'ion ion-android-people',
                                page: '/team-management/users',
                                translate: 'MENU.USERS',
                                bullet: 'dot',
                            },
                        ]
                    },
                });
                break;
            case 'system-management':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: 'システム設定',
                                root: true,
                                icon: 'ion ion-ios-settings-strong',
                                page: '/system-management',
                                translate: 'MENU.SYSTEM_MANAGEMENT',
                                bullet: 'dot',
                                'custom-class': 'kt-menu__home',
                            },
                            {
                                section: 'System'
                            },
                            {
                                title: 'チーム一覧',
                                root: true,
                                page: '/system-management/japan-teams',
                                translate: 'MENU.JAPAN_TEAM_LIST',
                                bullet: 'dot',
                            },
                            {
                                title: 'チーム一覧',
                                root: true,
                                page: '/system-management/overseas-teams',
                                translate: 'MENU.OVERSEAS_TEAM_LIST',
                                bullet: 'dot',
                            },
                            {
                                title: '顧客一覧',
                                root: true,
                                page: '/system-management/spaces',
                                translate: 'SPACE_MANAGEMENT.LIST_OF_CUSTOMER',
                                bullet: 'dot',
                            },
                            {
                                title: '顧客（SUUMO様）一覧',
                                root: true,
                                page: '/system-management/suumo-spaces',
                                translate: 'SPACE_MANAGEMENT.LIST_OF_SUUMO_SPACE',
                                bullet: 'dot',
                            },
                            {
                                title: 'グループ一覧',
                                root: true,
                                page: '/system-management/user-groups',
                                translate: 'SPACE_MANAGEMENT.LIST_OF_USER_GROUP',
                                bullet: 'dot',
                            },
                        ]
                    },
                });
                break;
            case 'direct-chat-management':
                this.loadConfigs({
                    header: {
                        self: {},
                        items: [
                            {
                                title: 'ダッシュボード',
                                icon: 'ion ion-home',
                                root: true,
                                alignment: 'left',
                                page: '/dashboard',
                                translate: 'MENU.DASHBOARD'
                            },
                            {
                                title: 'プロジェクト',
                                root: true,
                                alignment: 'left',
                                page: '/project-management',
                                translate: 'MENU.PROJECTS'
                            }
                        ]
                    },
                    aside: {
                        self: {},
                        items: [
                            {
                                title: 'Chat Groups',
                                root: true,
                                icon: 'ion ion-android-list',
                                page: '/direct-chat-management/direct-chat',
                                translate: 'MENU.CHAT_GROUPS',
                                bullet: 'dot',
                            },
                            {
                                title: 'Files',
                                root: true,
                                icon: 'ion ion-folder',
                                page: '/direct-chat-management/files',
                                translate: 'MENU.FILES',
                                bullet: 'dot',
                            },
                        ]
                    },
                });
                break;
        }
    }
}
